<template>
  <div v-if="getAvatar" class="profile-container" data-comp="profile">
    <div class="profile" @click="toggleProfileDropdown" data-comp="profile">
      <img
        class="avatar"
        :src="getAvatar.thumbnail_image"
        alt="avatar"
        data-comp="profile"
      />
      <img
        v-if="isUserPro"
        src="../../assets/images/navbar/pro-icon.svg"
        alt="pro icon"
        class="pro-icon"
        data-comp="profile"
      />
      <img
        src="../../assets/images/navbar/profile-dropdown.svg"
        alt="drop down"
        class="profile-icon"
        data-comp="profile"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  computed: {
    ...mapGetters("User", ["isUserPro"]),
    ...mapGetters("User/Profile", ["getAvatar"]),
  },
  methods: {
    ...mapActions("Util", ["toggleProfileDropdown"]),
    ...mapMutations("Util", ["setProfileDropdownShowing"]),
  },
}
</script>

<style lang="scss" scoped>
.profile {
  margin-left: 2.5rem;
  margin-right: 3rem;
  position: relative;
  display: flex;
  align-items: center;

  cursor: pointer;
  .avatar {
    width: 3.7rem;
    height: 3.7rem;
    border-radius: 50%;
    object-fit: center;
    object-position: center;
    margin-right: 0.8rem;
  }
  .pro-icon {
    position: absolute;
    top: -0.5rem;
    right: 1.2rem;
  }
}

.login {
  text-decoration: none;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-15px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Profile.vue